/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import { FC, useEffect } from 'react'
import { Redirect, Route, Switch, useHistory, useLocation } from 'react-router-dom'
// import {shallowEqual, useSelector} from 'react-redux'
import { MasterLayout } from '../../_metronic/layout/MasterLayout'
import { AuthPage } from '../modules/auth'
import { PrivateRoutes } from './PrivateRoutes'
// import {RootState} from '../../setup'
import { useDispatch } from 'react-redux'
import { useUser } from '../../_helper/userHooks/userHook'
import { MasterInit } from '../../_metronic/layout/MasterInit'
import { FallbackView } from '../../_metronic/partials'
import { clearClientID, clearPatient } from '../pages/admin/care/individual-intake/store'
import InitialPasswordChangeModal from '../pages/users/initialPasswordChangeModal'

const Routes: FC = () => {
  const history = useHistory()
  const location = useLocation()
  const path = location.pathname
  const dispatch = useDispatch()

  const obj = useUser()
  const role = obj?.user?.roleName
  useEffect(() => {
    if (!path.includes('/admin/care')) {
      dispatch(clearPatient());
      dispatch(clearClientID())
    }
  }, [path]);

  useEffect(() => {
    if (obj.loaded && !obj.authenticated) {
      // localStorage.clear()
      //  history.push('/auth/login')
      return
    }
  }, [obj.loaded, obj.authenticated, history])

  if (!obj.loaded) {
    return <FallbackView />
  }

  return (
    <>
      <Switch>
        {obj.loaded && !obj.authenticated ? (
          /*Render auth page when user at `/auth` and not authorized.*/
          <Route>
            <AuthPage />
          </Route>
        ): (
          /*Otherwise redirect to root page (`/`)*/
          <Redirect from='/auth' to='/' />
        )
      }

        {/* <Route path='/error' component={ErrorsPage} /> */}

        <Route path='/changeInitialPassword' component={InitialPasswordChangeModal} />

        {obj.loaded && !obj.authenticated ? (
          /*Redirect to `/auth` when user is not authorized*/
          <Redirect to='/auth/login' />
        ) : (
          <>
            <MasterLayout role={role}>
              <PrivateRoutes />
            </MasterLayout>
          </>
        )}
      </Switch>
      <MasterInit />
    </>
  )
}

export { Routes }

